<template>
  <div :class="['monthPicker', className]">
    <el-form
      class="jc-table-actionBar-item"
      :inline="true"
      :model="form"
      ref="form"
    >
      <el-form-item label="日期：">
        <el-row :gutter="20">
          <el-col :span="11">
            <el-date-picker
              v-model="form.beginTime"
              class="ml-6px"
              type="month"
              placeholder="请选择开始月份"
              :picker-options="pickerOptionsStart"
              :clearable="false"
            >
            </el-date-picker>
          </el-col>

          <el-col :span="2">
            <span class="label">至</span>
          </el-col>

          <el-col :span="11">
            <el-date-picker
              v-model="form.endTime"
              type="month"
              placeholder="请选择结束月份"
              :picker-options="pickerOptionsEnd"
              :clearable="false"
            >
            </el-date-picker>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import {} from '@/utils/contant.js'
import { getDate } from '@/utils'
export default {
  mixins: [],
  props: ['beginTime', 'endTime', 'maxMonth', 'lockYear', 'className'],
  //beginTime 默认开始时间
  //endTime 默认结束时间
  //maxMonth 开始时间与结束时间间隔
  //lockYear 是否不可跨年
  //class名
  data() {
    return {
      form: {
        beginTime: this.beginTime || getDate(new Date()).ym,
        endTime: this.endTime || getDate(new Date()).ym,
      },
      max: this.maxMonth || 0,
    }
  },
  computed: {
    pickerOptionsStart() {
      let _this = this
      return {
        disabledDate(time) {
          const endTime = new Date(_this.form.endTime).getTime()
          const beginTime = new Date(_this.form.beginTime).getTime()
          const beginLen = getDate(new Date(_this.form.beginTime)).mth - 1
          if (_this.max !== 0) {
            if (_this.lockYear) {
              return (
                time.getTime() <
                  endTime - 3600 * 1000 * 24 * (30 * _this.max) ||
                //时间小于结束时间-12个月的置灰
                time.getTime() <
                  beginTime - 3600 * 1000 * 24 * (30 * beginLen) ||
                //时间小于开始时间-开始时间月份-1的置灰
                time.getTime() > endTime //时间大于结束时间的置灰
              )
            } else {
              return (
                time.getTime() <
                  endTime - 3600 * 1000 * 24 * (30 * _this.max) ||
                time.getTime() > endTime
              )
            }
          } else {
            return time.getTime() > endTime
          }
        },
      }
    },
    pickerOptionsEnd() {
      let _this = this
      return {
        disabledDate(time) {
          const beginTime = new Date(_this.form.beginTime).getTime()
          const endTime = new Date(_this.form.endTime).getTime()
          const endLen = 12 - getDate(new Date(_this.form.endTime)).mth + 1
          if (_this.max !== 0) {
            if (_this.lockYear) {
              return (
                time.getTime() >
                  beginTime + 3600 * 1000 * 24 * (30 * _this.max) ||
                //时间小于开始时间-12个月的置灰
                time.getTime() > endTime + 3600 * 1000 * 24 * (30 * endLen) ||
                //时间小于12-结束时间-开始时间的置灰
                time.getTime() < beginTime //时间小于开始时间的置灰
              )
            } else {
              return (
                time.getTime() >
                  beginTime + 3600 * 1000 * 24 * (30 * _this.max) ||
                time.getTime() < beginTime
              )
            }
          } else {
            return time.getTime() < beginTime
          }
        },
      }
    },
  },
  watch: {
    'form.beginTime'() {
      this.$emit('change', this.resetDate())
    },
    'form.endTime'() {
      this.$emit('change', this.resetDate())
    },
  },
  created() {},
  methods: {
    //重置beginTime和endTime
    resetDate() {
      let beginTime =
        typeof this.form.beginTime === 'string'
          ? this.form.beginTime
          : getDate(this.form.beginTime).ym
      let endTime =
        typeof this.form.endTime === 'string'
          ? this.form.endTime
          : getDate(this.form.endTime).ym
      return {
        beginTime,
        endTime,
      }
    },
  },
}
</script>

<style scoped="true">
.monthPicker {
  height: 32px;
}
.monthPicker .el-form-item {
  margin: 0px;
}
.monthPicker .el-form-item .el-input {
  width: 100%;
}
.label {
  font-size: 12px;
}
</style>
